/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IncomingChatMessage
 */
export interface IncomingChatMessage {
    /**
     * 
     * @type {string}
     * @memberof IncomingChatMessage
     */
    role?: string;
    /**
     * 
     * @type {string}
     * @memberof IncomingChatMessage
     */
    content?: string;
}

/**
 * Check if a given object implements the IncomingChatMessage interface.
 */
export function instanceOfIncomingChatMessage(value: object): value is IncomingChatMessage {
    return true;
}

export function IncomingChatMessageFromJSON(json: any): IncomingChatMessage {
    return IncomingChatMessageFromJSONTyped(json, false);
}

export function IncomingChatMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncomingChatMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'role': json['role'] == null ? undefined : json['role'],
        'content': json['content'] == null ? undefined : json['content'],
    };
}

export function IncomingChatMessageToJSON(json: any): IncomingChatMessage {
    return IncomingChatMessageToJSONTyped(json, false);
}

export function IncomingChatMessageToJSONTyped(value?: IncomingChatMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'role': value['role'],
        'content': value['content'],
    };
}

